export const COURSE_MODULES_IMAGE_PATH = '/images/course-modules/'

export const MODULE_STATE = {
  UPCOMING: 'Upcoming',
  ONGOING: 'Ongoing',
  COMPLETED: 'Completed',
} as const

export const LESSON_STATE = {
  COMPLETED: 'Previous',
  ONGOING: 'Ongoing',
  NEXT_UPCOMING: 'next-upcoming', // Immediate next lesson
  UPCOMING: 'Upcoming',
} as const

export const MODULE_TABLE_LABELS = {
  UPCOMING: 'Upcoming Modules',
  ONGOING: 'Ongoing Module',
  FIRST: 'First Module',
  COMPLETED: 'Completed Modules',
}

export const FIRST_MODULE_QUERY = 'firstModule'

export const LESSON_CONTAINER_CLASS = 'lessonContainer'

export const MODULE_DIFFICULTY = {
  BEGINNER: 'Beginner',
  INTERMEDIATE: 'Intermediate',
  EXPERT: 'Expert',
} as const

export const MAXIMUM_PAGE_SIZE = 3
